import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import SourceActionsAPI from 'dashboard/api/sourceActions';
import types from 'dashboard/store/mutation-types';

// Source actions (complaint on a review, editing the published reply) return
// the updated conversation JSON, which is merged back into the store.
export function useSourceActions() {
  const store = useStore();
  const isSubmitting = ref(false);

  const applyConversation = data => {
    if (data?.id) store.commit(types.UPDATE_CONVERSATION, data);
  };

  const sendComplaint = async (conversationId, payload) => {
    isSubmitting.value = true;
    try {
      const { data } = await SourceActionsAPI.complaint(
        conversationId,
        payload
      );
      applyConversation(data);
    } finally {
      isSubmitting.value = false;
    }
  };

  const editReply = async (conversationId, message, content) => {
    isSubmitting.value = true;
    try {
      const { data } = await SourceActionsAPI.editReply(
        conversationId,
        content
      );
      applyConversation(data);
      if (message) store.commit(types.ADD_MESSAGE, { ...message, content });
    } finally {
      isSubmitting.value = false;
    }
  };

  return { isSubmitting, sendComplaint, editReply };
}
